/**
 * FAVORITES ROUTES
 */

export default [
  {
    path: '/:lang?/library',
    component: () => import(/* webpackChunkName: "library" */ '@/views/Library.vue'),
    children: [
      {
        path: 'download',
        redirect: 'downloads',
      },
      {
        path: 'downloads',
        name: 'library-download',
        component: () => import('@/views/library/DownloadContent.vue'),
      },
      {
        path: 'favorites',
        name: 'library-favorites',
        component: () => import('@/views/library/FavoritesContent.vue'),
      },
      {
        path: 'history',
        name: 'library-history',
        component: () => import('@/views/library/HistoryContent.vue'),
      },
      {
        path: ':folderId',
        name: 'library-folder',
        component: () => import('@/views/library/FolderContent.vue'),
      },
      {
        path: 'member/:hashId',
        name: 'library-member',
        component: () => import('@/views/library/MemberContent.vue'),
      },
      {
        path: 'member/:hashId/:folderId',
        name: 'library-member-folder',
        component: () => import('@/views/library/MemberContent.vue'),
      },
      {
        path: '',
        redirect: 'downloads',
      },
      {
        path: 'favorites/default',
        redirect: 'favorites',
      },
      {
        path: 'favorites/all',
        redirect: 'favorites',
      },
    ],
  },
  {
    path: '/:lang?/history/list',
    redirect: '/library/history',
  },
  {
    path: '/:lang?/lightbox/view/:folderId',
    redirect: '/:lang?/library/:folderId',
  },
];
